import { useEffect, useState } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/SEOHead';
import HeroSection from './components/HeroSection';
import CarPlaySection from './components/CarPlaySection';
import StarRoofSection from './components/StarRoofSection';
import AmbientLightingSection from './components/AmbientLightingSection';
import BackupCameraSection from './components/BackupCameraSection';
import OverviewSection from './components/OverviewSection';

export default function HomePage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://dsfcartech.be';

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "AutomotiveBusiness",
    "name": "DSF Cartech",
    "description": "Specialist in auto elektronica upgrades: CarPlay, Android Auto, sterrenhemel, sfeerverlichting en meer in Antwerpen.",
    "url": siteUrl,
    "logo": "https://static.readdy.ai/image/9e62058216dff63d1a686833c97014ce/727bcd7add4cd840d4bb2a3f870f0b81.png",
    "image": "https://static.readdy.ai/image/9e62058216dff63d1a686833c97014ce/727bcd7add4cd840d4bb2a3f870f0b81.png",
    "telephone": "+32489170592",
    "email": "Dsf.cartech@hotmail.com",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Ternesselei 191",
      "addressLocality": "Wommelgem",
      "addressRegion": "Antwerpen",
      "postalCode": "2160",
      "addressCountry": "BE"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "51.2194",
      "longitude": "4.4025"
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "08:00",
        "closes": "18:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": "Saturday",
        "opens": "09:00",
        "closes": "16:00"
      }
    ],
    "priceRange": "€€",
    "areaServed": {
      "@type": "City",
      "name": "Antwerpen"
    }
  };

  return (
    <>
      <SEOHead
        title="DSF Cartech Antwerpen - CarPlay, Sterrenhemel & Sfeerverlichting Installatie"
        description="DSF Cartech Antwerpen: specialist in CarPlay installatie, Android Auto, sterrenhemel, RGB sfeerverlichting en achteruitrijcamera's. Professionele auto-upgrades in Wommelgem, Antwerpen."
        keywords="DSF Cartech, auto elektronica Antwerpen, CarPlay installatie Antwerpen, sterrenhemel auto, sfeerverlichting auto, Android Auto, achteruitrijcamera, auto upgrades Antwerpen, Wommelgem"
        canonical={siteUrl}
        schema={organizationSchema}
      />
      
      <div className="bg-black text-white overflow-x-hidden">
        <Navigation />
        
        {/* Hero Section */}
        <HeroSection />
        
        {/* CarPlay Section */}
        <CarPlaySection />
        
        {/* Star Roof Section */}
        <StarRoofSection />
        
        {/* Ambient Lighting Section */}
        <AmbientLightingSection />
        
        {/* Backup Camera Section */}
        <BackupCameraSection />
        
        {/* Overview Section */}
        <OverviewSection />
        
        <Footer />
      </div>
    </>
  );
}
